var React = require('react');

function IcnPhone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.15625 10.6204C9.32494 9.54918 12.6438 7.12492 12.6438 7.12492L6.68125 1.2052C6.68125 1.2052 1 4.86973 1 6.8994C1 14.4541 14.7813 28.2668 22.3188 28.2668C24.3439 28.2668 28 22.5726 28 22.5726L22.0375 16.6528C22.0375 16.6528 19.6188 19.9792 18.55 20.1483C14.6125 20.7685 8.48125 14.6233 9.15625 10.6204V10.6204Z","stroke":"black","strokeMiterlimit":"10","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.6438 3.46027L9.8313 9.60549","stroke":"black","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M19.675 19.4717L25.8063 25.6733","stroke":"black","strokeMiterlimit":"10","key":2})]);
}

IcnPhone.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = IcnPhone;

IcnPhone.default = IcnPhone;
